import axios from 'axios'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  const apiURL = runtimeConfig.public.apiBase

  const username = runtimeConfig.public.username
  const password = runtimeConfig.public.password

  const headers = {
    'Access-Control-Allow-Methods': 'GET,HEAD,PATCH,POST,DELETE',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  }

  if (username && password) {
    const authToken = btoa(`${username}:${password}`)
    headers.Authorization = `Basic ${authToken}`
  }

  // Create an Axios instance
  const axiosInstance = axios.create({
    baseURL: apiURL,
    headers,
  })

  axiosInstance.interceptors.request.use((config) => {
    return config
  })

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  nuxtApp.provide('axios', axiosInstance)
})
